import { Colors, TextVariants } from '@lichtblick/theme';

import { CrumbItem, IconWrapper } from './Crumb.styles';

import { Text } from '../../Text';

type CrumbProps = {
  hasDivider?: boolean;
  href: string;
  icon?: React.ReactElement;
  isActive?: boolean;
  label: string;
};

export const Crumb = ({ hasDivider, href, icon, isActive, label }: CrumbProps) => {
  return (
    <CrumbItem $isActive={!!isActive} href={href}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <Text $variant={TextVariants.button.s}>{label}</Text>
      {hasDivider && <Text $variant={TextVariants.button.s}>/</Text>}
    </CrumbItem>
  );
};

export const Divider = () => {
  return (
    <Text $variant={TextVariants.button.s} color={Colors.gray[20]}>
      /
    </Text>
  );
};
